import React from 'react';
import './ShopControls.css';

const subCategoryMap = {
  'Services': ['All', 'Video Games', 'Computers', 'Other'],
  'Custom Products': ['All', 'Controllers', 'Cases', 'Accessories'],
};

// New data structure for the third-level filter
const brandMap = {
  'Video Games': ['All', 'Nintendo', 'Microsoft', 'Sony', 'SEGA', 'Other'],
};

const ShopControls = ({ filters, setFilters, sortBy, setSortBy }) => {
  
  const handleCategoryChange = (e) => {
    const newCategory = e.target.value;
    // When the main category changes, reset both sub-category and brand
    setFilters({ category: newCategory, subCategory: 'all', brand: 'all' });
  };

  const handleSubCategoryChange = (e) => {
    const newSubCategory = e.target.value;
    // When the sub-category changes, reset the brand
    setFilters(prevFilters => ({ ...prevFilters, subCategory: newSubCategory, brand: 'all' }));
  };
  
  const handleBrandChange = (e) => {
    setFilters(prevFilters => ({ ...prevFilters, brand: e.target.value }));
  };

  const handleSortChange = (e) => {
    setSortBy(e.target.value);
  };

  // Determine if sub-category and brand dropdowns should be shown
  const availableSubCategories = subCategoryMap[filters.category];
  const availableBrands = brandMap[filters.subCategory];

  return (
    <div className="shop-controls">
      <div className="control-group">
        <label htmlFor="category-filter">Filter by Category</label>
        <select id="category-filter" value={filters.category} onChange={handleCategoryChange}>
          <option value="all">All Categories</option>
          <option value="Services">Services</option>
          <option value="Custom Products">Custom Products</option>
          <option value="Accessories">Accessories</option>
          <option value="Other">Other</option>
        </select>
      </div>

      {availableSubCategories && (
        <div className="control-group">
          <label htmlFor="subcategory-filter">Filter by Type</label>
          <select id="subcategory-filter" value={filters.subCategory} onChange={handleSubCategoryChange}>
            {availableSubCategories.map(sub => (
              <option key={sub} value={sub}>{sub}</option>
            ))}
          </select>
        </div>
      )}
      
      {/* Conditionally render the new brand filter */}
      {filters.category === 'Services' && availableBrands && (
        <div className="control-group">
          <label htmlFor="brand-filter">Filter by Brand</label>
          <select id="brand-filter" value={filters.brand} onChange={handleBrandChange}>
            {availableBrands.map(brand => (
              <option key={brand} value={brand}>{brand}</option>
            ))}
          </select>
        </div>
      )}

      <div className="control-group">
        <label htmlFor="sort-by">Sort by</label>
        <select id="sort-by" value={sortBy} onChange={handleSortChange}>
          <option value="name-asc">Name (A-Z)</option>
          <option value="name-desc">Name (Z-A)</option>
          <option value="price-asc">Price (Low to High)</option>
          <option value="price-desc">Price (High to Low)</option>
        </select>
      </div>
    </div>
  );
};

export default ShopControls;